import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { buildParams, parseURL } from '../../../global/js/url';
import SearchContext from '../data/FunnelbackContext';
import styles from '../../css/functional.module.scss';

/**
 * Renders search tabs (based on facets) and handles logic related to them.
 *  @param {bool} tabKeepFilters flag to determine if switching through tabs should remember filters
 *  @param {bool} currentTabResults flag to determine if number of results should be displayed on current tab
 *
 * @returns {JSX.Element}
 * @constructor
 */

function SearchTabs({ tabKeepFilters, currentTabResults }) {
    const { fetchResults, facets, queryString, setQueryString, setActiveTab } = useContext(SearchContext);

    const resultsTabs = facets.filter((facet) => facet.guessedDisplayType === 'TAB')[0];

    const onTabClickHandler = (event) => {
        const tabSelected = { [event.target.getAttribute('data-tab')]: event.target.getAttribute('data-name') };
        let urlParams = parseURL(queryString.replace(/f\..*?&|f\..*?$/g, ''));

        if (tabKeepFilters) {
            urlParams = parseURL(queryString.replace(/f\.Tabs.*?&|f\.Tabs.*$/g, ''));
        }
        const newParams = buildParams({ ...urlParams, ...tabSelected }, true, true);

        setActiveTab(tabSelected);
        setQueryString(newParams);
        fetchResults(event, newParams);
    };

    // Return nothing if facets are empty
    if (!facets || facets.length === 0) {
        return '';
    }

    return (
        <div id="funnelback-instant-search-tabs" className={`funnelback-instant-search-tabs ${styles.tabs}`}>
            {resultsTabs.allValues.map((tab) => {
                let tabCount = `(${tab.count})`;
                if (tab.selected && !currentTabResults) {
                    tabCount = '';
                }
                return (
                    <button
                        key={tab.data}
                        className={`funnelback-instant-search-tabs__button ${styles.tabsButton} ${
                            tab.selected ? 'funnelback-instant-search-tabs__button--active' : ''
                        }`}
                        type="button"
                        role="tab"
                        aria-selected={tab.selected}
                        tabIndex={0}
                        data-name={tab.label}
                        data-tab={`f.Tabs|${tab.data}`}
                        onClick={onTabClickHandler}
                    >
                        {tab.label} {tabCount}
                    </button>
                );
            })}
        </div>
    );
}

SearchTabs.propTypes = {
    tabKeepFilters: PropTypes.bool,
    currentTabResults: PropTypes.bool,
};

SearchTabs.defaultProps = {
    tabKeepFilters: false,
    currentTabResults: false,
};

export default SearchTabs;
